import React from 'react'; 
import PortfolioContentSingle from '../../Components/Main/Portfolio/PortfolioContentSingle';
import '../../CSS/Main/portfolio.scss';

const PortfolioSingle = ()=> { 
  return (
    <div className="portfolio-single">
        <div className="portfolio-content-section">
          <PortfolioContentSingle/>
        </div>
    </div>
  );
}

export default PortfolioSingle; 